import React from 'react'
import Mychart from './chart'

const ChartContainer = (props) => {
    return <Mychart data = {props.chartData}/>
}

export default ChartContainer